import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LOGO_URL, BRAND, IMAGES } from "../brand";
import api from "../api";
import { mediaUrl } from "../media";
import { Sparkles, Clock, Heart, Users, ArrowRight } from "lucide-react";
import { SunflowerOrnament, SunflowerMini } from "../SunflowerOrnament";

export default function LandingPage() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then(r => setServices(r.data)).catch(()=>{}); }, []);

  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 pt-14 pb-16 grid lg:grid-cols-2 gap-14 items-center relative">
          <div className="reveal">
            <div className="tag-sun mb-6 inline-block" data-testid="hero-tag">Arya Studio K&amp;C · Agendamento ONLINE</div>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[color:var(--ink-900)]">
              Onde <em className="font-serif italic text-[color:var(--sun-600)]">cuidado</em> e
              <br/> beleza se <em className="font-serif italic text-[color:var(--sun-600)]">encontram</em>.
            </h1>
            <p className="mt-6 text-base text-[color:var(--ink-500)] max-w-xl leading-relaxed">
              Um estúdio de unhas dedicado a manicures de assinatura, cutilagem impecável e nail art autoral. Reserve seu horário em segundos.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/agendar" className="btn-gold inline-flex items-center gap-2" data-testid="hero-cta-book">
                Agendar meu horário <ArrowRight size={16}/>
              </Link>
              <Link to="/servicos" className="btn-ghost" data-testid="hero-cta-services">Ver especialidades</Link>
            </div>

            <div className="mt-10 flex items-center gap-8 text-xs font-display tracking-[0.3em] text-[color:var(--sun-700)]">
              <div className="flex items-center gap-2"><Clock size={14}/> AGENDA 24/7</div>
              <div className="flex items-center gap-2"><Heart size={14}/> CLUBE FIDELIDADE</div>
              <div className="flex items-center gap-2"><Users size={14}/> INDIQUE & GANHE</div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -top-8 -left-8 w-40 h-40 rounded-full bg-[var(--sun-300)]/30 blur-3xl"/>
            <div className="absolute -bottom-8 -right-8 w-56 h-56 rounded-full bg-[var(--sun-500)]/20 blur-3xl"/>
            <div className="relative grid grid-cols-2 gap-4">
              <div className="card-arya overflow-hidden aspect-[3/4] reveal-2">
                <img src={IMAGES.nude} alt="Nail art nude" className="w-full h-full object-cover"/>
              </div>
              <div className="flex flex-col gap-4 pt-8">
                <div className="card-arya overflow-hidden aspect-[4/5] reveal-3">
                  <img src={IMAGES.crafting} alt="Manicure" className="w-full h-full object-cover"/>
                </div>
                <div className="card-arya p-4 flex items-center gap-3 reveal-3">
                  <img src={LOGO_URL} alt="" className="w-14 h-14 object-contain"/>
                  <div>
                    <p className="font-script text-lg text-[color:var(--sun-600)]">{BRAND.tagline}</p>
                    <p className="text-[10px] tracking-[0.3em] text-[color:var(--ink-500)]">ARYA STUDIO · SINCE 2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES PREVIEW */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="tag-sun mb-3 inline-block">ESPECIALIDADES</div>
            <h2 className="font-serif text-3xl sm:text-4xl text-[color:var(--ink-900)]">Serviços de assinatura</h2>
          </div>
          <Link to="/servicos" className="hidden sm:inline-flex items-center gap-1 text-sm text-[color:var(--sun-700)]">
            Ver todos <ArrowRight size={14}/>
          </Link>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {services.slice(0,6).map(s => (
            <div key={s.service_id} className="card-arya overflow-hidden" data-testid={`service-card-${s.service_id}`}>
              {s.image_url && <div className="aspect-[4/3] overflow-hidden"><img src={mediaUrl(s.image_url)} alt={s.title} className="w-full h-full object-cover"/></div>}
              <div className="p-6">
              <div className="flex items-center justify-between mb-3">
                <span className="tag-sun">{s.category}</span>
                <Sparkles size={16} className="text-[color:var(--sun-500)]"/>
              </div>
              <h3 className="font-serif text-2xl text-[color:var(--ink-900)]">{s.title}</h3>
              <p className="text-sm text-[color:var(--ink-500)] mt-2 leading-relaxed">{s.description}</p>
              <div className="mt-5 flex items-center justify-between text-sm">
                <span className="font-display text-[color:var(--ink-700)]">{s.duration_min} min</span>
                <span className="font-serif text-xl text-[color:var(--sun-700)]">R$ {s.price.toFixed(2).replace('.', ',')}</span>
              </div>
              </div>
            </div>
          ))}
        </div>
      </section>



      {/* CTA */}
      <section className="max-w-7xl mx-auto px-6 py-16 text-center relative">
        <div className="divider-ornament max-w-md mx-auto mb-6 text-[color:var(--sun-600)]"><SunflowerMini size={18}/></div>
        <h2 className="font-serif text-3xl sm:text-4xl">Sua próxima manicure te espera</h2>
        <p className="text-[color:var(--ink-500)] mt-3">Agende online em menos de 1 minuto.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/agendar" className="btn-gold" data-testid="cta-book-now">Agendar agora</Link>
          <Link to="/cadastro" className="btn-ghost" data-testid="cta-register">Criar minha conta</Link>
        </div>
      </section>
    </div>
  );
}
